// extracted by mini-css-extract-plugin
export default {"mentionContent":"styles_mentionContent__chCDL","modalContent":"styles_modalContent__Ht9OD","title":"styles_title__bJwct","subTitle":"styles_subTitle__aJ4MI"};